import { ButtonDropdownProps } from '@amzn/awsui-components-react';
import { Layout } from 'plotly.js';

import { Partition } from '../../../common/DashboardLocalStorage';
import { constants } from '../../../common/Localization';

export enum ChartFunctions {
    COUNT = 'count',
    DISTINCT = 'distinct',
    SUM = 'sum',
    AVERAGE = 'average',
    MIN = 'min',
    MAX = 'max'
}

export const chartFunctions = [
    {label: 'Count', value: ChartFunctions.COUNT},
    {label: 'Count (distinct)', value: ChartFunctions.DISTINCT},
    {label: 'Sum', value: ChartFunctions.SUM},
    {label: 'Average', value: ChartFunctions.AVERAGE},
    {label: 'Minimum', value: ChartFunctions.MIN},
    {label: 'Maximum', value: ChartFunctions.MAX}
];

export enum ChartTypes {
    PIE = 'pie',
    DOUGHNUT = 'doughnut',
    LINE = 'line',
    BAR = 'bar',
    HORIZONTAL_BAR = 'horizontal-bar'
}

export const chartTypes = [
    { value: ChartTypes.HORIZONTAL_BAR, label: 'Bar (horizontal)' },
    { value: ChartTypes.BAR, label: 'Bar (vertical)' },
    { value: ChartTypes.DOUGHNUT, label: 'Doughnut' },
    { value: ChartTypes.LINE, label: 'Line' },
    { value: ChartTypes.PIE, label: 'Pie' }
];

export const MAX_CHART_DATA_LENGTH = 50;

export const defaultLayout: Partial<Layout> = {
    margin: { t: 40, r: 40, b: 40, l: 40 },
    xaxis : {
        automargin: true,
        fixedrange: true,
        autorange: true,
    },
    yaxis: {
        automargin: true,
        fixedrange: true,
        autorange: true,
    },
};

export const getChartActions = (areLabelsShown: boolean): ButtonDropdownProps.ItemOrGroup[] => {
    const baseActions: ButtonDropdownProps.ItemOrGroup[] = [
        {
            id: 'clone',
            text: constants.CLONE,
        },
        {
            id: 'edit',
            text: constants.EDIT_BUTTON_TEXT,
        },
        {
            id: 'remove',
            text: constants.REMOVE_BUTTON_TEXT,
        }
    ];

    return areLabelsShown ? 
        [{
            id: 'hideLabels',
            text: constants.HIDE_LABELS,
        }, ...baseActions] : [{
            id: 'showLabels',
            text: constants.SHOW_LABELS,
        }, ...baseActions];
};

export const MAX_PARTITION_COUNT = 10;

export const CARDS_PER_ROW = 2;

export const emptyPartition: Partition = {
    labels: [],
    upperBounds: []
};
